import type {
    MemberServerStorageListApiResponse,
    MemberServerStoragePutApiRequest,
    MemberServerStoragePutApiResponse
} from 'tradera/state/services/types/webapi-member-generated';
import { webApi, webApiTags } from 'tradera/state/services/webapi-api';
import { isServer } from 'tradera/utils/nextjs';

export const memberServerStorageApi = webApi.injectEndpoints({
    endpoints: (builder) => ({
        getMemberServerStorage: builder.query<
            MemberServerStorageListApiResponse,
            void
        >({
            providesTags: [webApiTags.MemberServerStorage],
            query: () => {
                const baseUrl = isServer ? '' : '/api/webapi';
                return `${baseUrl}/member/server-storage`;
            }
        }),
        addToMemberServerStorage: builder.mutation<
            MemberServerStoragePutApiResponse,
            MemberServerStoragePutApiRequest
        >({
            invalidatesTags: [webApiTags.MemberServerStorage],
            query: (params) => {
                const baseUrl = isServer ? '' : '/api/webapi';

                return {
                    url: `${baseUrl}/member/server-storage`,
                    method: 'PUT',
                    body: params
                };
            }
        })
    })
});

export const { endpoints, useAddToMemberServerStorageMutation } =
    memberServerStorageApi;
